const config = window.myConfig;

export default config;